import { render, staticRenderFns } from "./PagamentoServicos.vue?vue&type=template&id=01f4d6f2&scoped=true&"
import script from "./PagamentoServicos.vue?vue&type=script&lang=js&"
export * from "./PagamentoServicos.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoServicos.vue?vue&type=style&index=0&id=01f4d6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4d6f2",
  null
  
)

export default component.exports